function isSet(value) {
  return value !== null && value !== undefined && value !== "";
}

function storyEditorStyleOverrides({ borderRadius = null, backgroundColor = null } = {}) {
  const overrides = {};
  if (isSet(borderRadius)) {
    overrides.builderBorderRadius = borderRadius;
  }
  if (isSet(backgroundColor)) {
    overrides.backgroundColor = backgroundColor;
    overrides.hoverBackgroundColor = backgroundColor;
  }
  return overrides;
}

module.exports = { storyEditorStyleOverrides };
